<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Spread the Red</h1>
<p class="BOD2">Attach a bright red motif to a child’s cardigan, a hat, a bag, the sleeve of your jumper or hem of a skirt – where will you put yours?</p>
<p class="IMAGE"><img alt="" src="images/C1-5.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-6.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-3.vue?df3cb4f4